/* eslint-disable newline-after-var, no-invalid-this, prefer-template, object-shorthand, comma-dangle */
import _ from 'underscore';
import Backbone from 'backbone';
export type ConfigKey = string;
export type ConfigValue = unknown;
export type ConfigAttributes = Record<ConfigKey, ConfigValue>;
export type ConfigSetInput = ConfigKey | ConfigAttributes;

const hash: ConfigAttributes = {};
function get<T = ConfigValue>(key: ConfigKey): T {
  return hash[key] as T;
}
function set(this: Backbone.Events, key: ConfigSetInput, value?: ConfigValue): void {
  if (_.isString(key)) {
    hash[key] = value;
    this.trigger('init:' + key, value);
  } else if (_.isObject(key)) {
    _.extend(hash, key);
    _.each(key, function (v, k) {
      this.trigger('init:' + k, v);
    }, this);
  }
}
function has(key: ConfigKey): boolean {
  return _.has(hash, key);
}
function attributes(): ConfigAttributes {
  return _.clone(hash);
}

export type Config = Backbone.Events & {
  get: typeof get;
  set: typeof set;
  has: typeof has;
  attributes: typeof attributes;
};

const config: Config = _.extend({
  get: get,
  set: set,
  has: has,
  attributes: attributes
}, Backbone.Events);

export default config;
